import vueI18n from '@/lang'
const { global: { t }} = vueI18n

export default () => {

  return [
    // 首页
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 首页
    {
      path: '/home',
      redirect: '/',
      component: () => import('../views/home/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 所有圈子
    {
      path: '/allCircles',
      name: 'allCircles',
      component: () => import('../views/allCircles/wap'),
      meta: {
        title: t('allCircleTitle')
      }
    },
    // 我的圈子
    {
      path: '/myCircles',
      name: 'myCircles',
      component: () => import('../views/myCircles/wap'),
      meta: {
        title: t('myCircleTitle')
      }
    },
    // 圈子详情
    {
      path: '/circle/:id?/:tabId?',
      name: 'circle',
      component: () => import('../views/circle/wap'),
      meta: {
        title: t('homeTitle'),
        scrollDetail: []
      }
    },
    // 创建圈子
    {
      path: '/circle/create/:id?',
      name: 'circleCreate',
      component: () => import('../views/createCircle/wap'),
      meta: {
        title: t('allCircleTitle')
      }
    },
    // 话题广场
    {
      path: '/topics',
      name: 'topics',
      component: () => import('../views/topicCenter/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 话题详情
    {
      path: '/topic/:id?',
      name: 'topic',
      component: () => import('../views/topicDetail/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 我的草稿箱
    {
      path: '/myDraft',
      name: 'myDraft',
      redirect: '/',
      component: () => import('../views/myDraft/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 系统消息
    {
      path: '/message',
      name: 'message',
      component: () => import('../views/message/wap'),
      meta: {
        title: t('socialTitle'),
        pageName: t('social')
      }
    },
    // 发贴
    {
      path: '/post/:type?/:id?',
      name: 'post',
      component: () => import('../views/post/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 帖子详情
    {
      path: '/thread/:id?',
      name: 'thread',
      component: () => import('../views/thread/wap'),
      meta: {
        title: t('homeTitle'),
        scrollDetail: []
      }
    },
    // 个人详情
    {
      path: '/user/:id?',
      name: 'user',
      component: () => import('../views/user/wap'),
      meta: {
        title: t('homeTitle'),
        scrollDetail: []
      }
    },
    // myoppo会员嵌入页
    {
      path: '/abroadList',
      name: 'abroadList',
      component: () => import('../views/abroadList/wap'),
      meta: {
        title: t('homeTitle'),
      }
    },
    // 积分中心    
    {
      path: '/creditCenter',
      name: 'creditCenter',
      component: () => import('../views/creditCenter'),
      meta: {
        title: t('homeTitle'),
      }
    },
    // 积分中心兑换积分
    {
      path: '/creditCenter/creditExchange',
      name: 'creditCenterExchange',
      component: () => import('../views/creditCenter/creditExchange'),
      meta: {
        title: t('homeTitle'),
      }
    },
    // 积分中心历史
    {
      path: '/creditCenter/history',
      name: 'creditCenterHistory',
      component: () => import('../views/creditCenter/history'),
      meta: {
        title: t('homeTitle'),
      }
    },
    // 抽奖
    {
      path: '/raffleForm/:id?',
      name: 'raffleForm',
      component: () => import('../views/raffleForm'),
      meta: {
        title: t('homeTitle'),
      }
    },
    // 报名活动表单页
    {
      path: '/form/:id?',
      name: 'form',
      component: () => import('../views/activityForm/wap'),
      meta: {
        title: t('homeTitle'),
        pageName: t('pageName.application')
      }
    },
    // 隐私协议
    {
      path: '/privacy-notice',
      name: 'privacyNotice',
      component: () => import('../views/privacyNotice'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.privacyNotice')
      }
    },
    // 隐私协议
    {
      path: '/privacy_notice',
      redirect: '/privacy-notic',
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.privacyNotice')
      }
    },
    // 1+app协议地址
    {
      path: "/privacy-policy",
      name: "privacyPolice",
      component: () => import('../views/privacyNotice'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.privacyNotice')
      }
    },
    // 1+简版政策
    {
      path: "/simple-privacy-notice",
      name: "simplePrivacyNotice",
      component: () => import('../views/chinaPrivacy'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.privacyNotice')
      }
    },
    // 一加国内 第三方共享清单
    {
      path: "/sharedList",
      name: "sharedList",
      component: () => import('../views/chinaPrivacy'),
      meta: {
        title: t('homeTitle'),
        privacy: true
      }
    },
    // 一加国内 收集个人信息明示清单
    {
      path: "/personalCollected",
      name: "personalCollected",
      component: () => import('../views/chinaPrivacy'),
      meta: {
        title: t('homeTitle'),
        privacy: true
      }
    },
    // 一加国内 用户举报列表
    {
      path: "/reportList",
      name: "reportList",
      component: () => import('../views/chinaPrivacy'),
      meta: {
        title: t('homeTitle'),
        privacy: true
      }
    },
    // 一加国内 应用权限申请与使用说明
    {
      path: "/application",
      name: "application",
      component: () => import('../views/chinaPrivacy'),
      meta: {
        title: t('homeTitle'),
        privacy: true
      }
    },
    // cookie使用需知
    {
      path: '/useOfCookies',
      name: 'useOfCookies',
      component: () => import('../views/useOfCookies'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.cookieStatement')
      }
    },
    // 使用条款
    {
      path: '/termsOfUse',
      name: 'termsOfUse',
      component: () => import('../views/termsOfUse'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.terms')
      }
    },
    // 使用条款（旧）
    {
      path: '/terms-of-use',
      redirect: '/termsOfUse',
      name: 'terms-of-use',
      component: () => import('../views/termsOfUse'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.terms')
      }
    },
    // 用户协议
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('../views/userAgreement'),
      meta: {
        title: t('homeTitle'),
        privacy: true,
        pageName: t('pageName.userAgreement')
      }
    },
    // 1+App登录中转页
    {
      path: "/opLogin",
      name: "opLogin",
      component: () => import('../views/oneplusAppLogin'),
      meta: {
        title: t('homeTitle'),
        privacy: true
      }
    },
    // 邀请制 - 邀请页
    {
      path: "/inviteFriends/:id?",
      name: "inviteFriends",
      component: () => import('../views/inviteFriends/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
     // 邀请制 - 中奖名单页 & 我的邀请列表
    {
      path: "/winningList/:id?",
      name: "winningList",
      component: () => import('../views/winningList/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 邀请制 - 被邀请页
    {
      path: "/invitation/:id?",
      name: "invitation",
      component: () => import('../views/invitation/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 邀请制 - 被邀请页
    {
      path: "/historyPrivacy",
      name: "historyPrivacy",
      component: () => import('../views/historyPrivacy'),
      meta: {
        title: t('homeTitle')
      },
    },
    // poc主页
    {
      path: "/powerOfCommunity",
      name: "powerOfCommunity",
      component: () => import('../views/powerOfCommunity/wap'),
      meta: {
        title: t('poc.powerCommunity')
      }
    },
    // 代替poc的链接入口
    {
      path: "/product/:id?",
      name: "product",
      component: () => import('../views/poc/wap'),
      meta: {
        title: t('poc.powerCommunity')
      }
    },
    {
      path: "/ambassador/:id?/:productId?",
      name: 'ambassador',
      component: () => import('../views/ambassador/wap'),
      meta: {
        title: t('contentCenter.ambassador')
      }
    },
    {
      path: "/merchaindise",
      name: 'merchaindise',
      component: () => import('../views/merchaindise'),
      meta: {
        title: t('contentCenter.merchaindise')
      }
    },
    {
      path: "/ShotonOPPO",
      name: 'ShotonOPPO',
      component: () => import('../views/shootOnOppo'),
      meta: {
        title: t('contentCenter.ShotonOPPO')
      }
    },
    {
      path: "/ShotonOnePlus",
      name: 'ShotonOnePlus',
      component: () => import('../views/shootOnOppo'),
      meta: {
        title: t('contentCenter.ShotonOnePlus')
      }
    },
    // 作品展示列表
    {
      path: "/gallery/:id?",
      name: "gallery",
      component: () => import('../views/ambassador/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 周年庆
    {
      path: "/activities",
      name: "activities",
      component: () => import('../views/activities'),
      meta: {
        title: t(`framepage.${import.meta.env.VITE_COUNTRY}Title`),
        description: t(`framepage.${import.meta.env.VITE_COUNTRY}Description`)
      }
    },
    // 周年庆抽奖
    {
      path: "/carnival-2023",
      name: "annualRaffle",
      component: () => import('../views/activities/raffle'),
      meta: {
        title: t('framepage.draw'),
      }
    },
     // 周边
    {
      path: "/oppo-life-studio",
      children: [
        {
          path: ":id",
          name: "lifeStudioProduct",
          component: () => import('../views/lifeStudioProduct/wap'),
          meta: {
            title: t('lifeStudio.lifeStudioProduct'),
          }
        },
        {
          path: "",
          name: "lifeStudio",
          component: () => import('../views/lifeStudio/wap'),
          meta: {
            title: t('lifeStudio.lifeStudio'),
            description: t('lifeStudio.lifeStudioDesc'),
          }
        },
        {
          path: "ollie-elemental-collection-worldwide-wishes-contest",
          name: "ollieActivities",
          component: () => import('../views/activities'),
          meta: {
            title: t('framepage.GLOBALTitle'),
            description: t('framepage.GLOBALDescription'),
            pageName: ''
          }
        }
      ]
    },
    // 周边详情
    {
      path: "/my-canvas/:id?",
      redirect: '/oppo-life-studio/product/my-canvas/:id?',
      component: () => import('../views/lifeStudioProduct/wap'),
      meta: {
        title: t('lifeStudio.lifeStudioProduct'),
      }
    },
    {
      // AR
      path: "/see-dream-higher-ollie-in-ar",
      name: "AR",
      component: () => import('../views/activities/ar'),
      meta: {
        title: t('framepage.ar'),
      }
    },
    // Privacy Statement of the User Experience Program
    {
      path: "/privacyStatement",
      name: "privacyStatement",
      component: () => import('../views/privacyStatement'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 直播
    {
      path: "/livestream/:id?/:youtubeId?",
      name: "livestream",
      component: () => import('../views/livestream/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 测试页
    {
      path: "/tester",
      name: "tester",
      component: () => import('../views/tester'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 勋章大厅
    {
      path: "/medals/:id?",
      name: "medals",
      component: () => import('../views/medals/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 勋章大厅对应分类列表
    {
      path: "/medalsList/:id?/:type?",
      name: "medalsList",
      component: () => import('../views/medalsList/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 勋章详情
    {
      path: "/medalDetail/:id?/:uid?",
      name: "medalDetail",
      component: () => import('../views/medalDetail/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 勋章关联签到页
    {
      path: "/signInPage/:id?",
      name: "signInPage",
      component: () => import('../views/signInPage/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 个人中心-会员体系-普通会员
    {
      path: "/milestones",
      name: "milestones",
      component: () => import('../views/milestones/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 个人中心-会员体系-创作者中心
    {
      path: "/inspiration-path",
      name: 'inspirationPath',
      component: () => import('../views/inspirationPath/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // 个人中心-会员体系-权益介绍页 
    {
      path: "/milestones-benefits/:id?/:type?",
      name: "milestonesBenefits",
      component: () => import('../views/rightsIntroduction/wap'),
      meta: {
        title: t('homeTitle'),
        pageName: t('memberShip.benefitsDetailTitle')
      }
    },
    // 个人中心-会员体系-权益介绍页 
    {
      path: "/inspiration-path-benefits/:id?/:type?",
      name: "inspirationPathBenefits",
      component: () => import('../views/rightsIntroduction/wap'),
      meta: {
        title: t('homeTitle'),
        pageName: t('memberShip.benefitsDetailTitle')
      }
    },
    // 个人中心-会员体系-成长值明细 
    {
      path: "/milestones-details",
      name: "milestonesDetails",
      component: () => import('../views/growthDetails/wap'),
      meta: {
        title: t('homeTitle')
      }
    }, {
      path: "/inspiration-path-details",
      name: "inspirationPathDetails",
      component: () => import('../views/growthDetails/wap'),
      meta: {
        title: t('homeTitle')
      }
    },
    // MyOPPO跳问卷表单隐私同意弹窗
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('../views/agreement'),
      meta: {
        title: 'OPPO FUT Program Recruitment',
      }
    }, 
    {
      path: '/offlineevents',
      children: [
        {
          path: "",
          name: "oneplusMeetup",
          component: () => import('../views/meetup/wap'),
          meta: {
            title: t('homeTitle'),
            pageName: ''
          }
        },
        {
          path: "more",
          name: "oneplusAboutmeetup",
          component: () => import('../views/aboutMeetup/web'),
          meta: {
            title: t('homeTitle'),
            pageName: ''
          }
        },
      ]
    },
    {
      path: '/oppomeetup',
      children: [
        {
          path: "",
          name: "oppoMeetup",
          component: () => import('../views/meetup/wap'),
          meta: {
            title: t('meetup.tabTitle'),
            description: t('meetup.tabDescription')
          }
        },
        {
          path: "more",
          name: "oppoAboutmeetup",
          component: () => import('../views/aboutMeetup/web'),
          meta: {
            title: t('homeTitle'),
            pageName: ''
          }
        },
      ]
    },
    {
      path: '/OnePlusAI',
      name: "OnePlusAI",
      component: () => import('../views/activities/oneplusAI'),
      meta: {
        title: 'OnePlusAI',
        pageName: 'OnePlusAI'
      }
    }, {
      path: "/OnePlusGaming",
      name: "OnePlusGaming",
      component: () => import('../views/activities/OnePlusGaming'),
      meta: {
        title: 'OnePlus Gaming',
        pageName: 'OnePlus Gaming',
      }
    }
  ]
}